import { get } from 'microcosm'
import * as Storage from './storage'
import Cookies from 'lib/cookies'
import RA from 'ra-config'

const OBSOLETE_KEYS = ['dashboardDisclaimerText']

export function isAccepted() {
  removeObsolete()
  return Storage.get(getKey(), false, Storage.StorageTypes.LOCAL_STORAGE)
}

export function getKey() {
  let storagePrefix = get(RA, ['app', 'disclaimerStoragePrefix'])
  let storageDate = get(RA, ['app', 'disclaimerStorageDate'])
  let storageKey = `${storagePrefix}${storageDate}`

  return storageKey
}

export function removeObsolete() {
  let storagePrefix = get(RA, ['app', 'disclaimerStoragePrefix'])

  Storage.removeWithPrefix(Storage.StorageTypes.LOCAL_STORAGE, storagePrefix, [
    getKey()
  ])

  OBSOLETE_KEYS.map(key =>
    Storage.remove(key, Storage.StorageTypes.LOCAL_STORAGE)
  )
}

export function accept() {
  Storage.set(getKey(), true, Storage.StorageTypes.LOCAL_STORAGE)
}

export function decline() {
  Cookies.clear()
  Storage.clear(Storage.StorageTypes.LOCAL_STORAGE)
  Storage.clear(Storage.StorageTypes.SESSION_STORAGE)

  let disclaimerRedirectPage = get(RA, ['app', 'disclaimerRedirectPage'])
  if (disclaimerRedirectPage) {
    window.location = disclaimerRedirectPage
  }
}

export default {
  isAccepted,
  getKey,
  accept,
  decline
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/disclaimer.js